export default __webpack_public_path__ + "static/media/man.e23f5595.svg";